
// © Microsoft Corporation. All rights reserved.

/**
 * Defines the different reasons why the hidden page should be reloaded on reveal
 */
export enum PageInvalidationReasons {
    MuidChange = 1,
    MarketChange = 2,
    InterestsChange = 3,
    PivotSwitch = 4,
    WeatherChange = 5,
    MoneyChange = 6,
    FeedLayoutSwitch = 7
}